/** @format */

import React from 'react'
import { _$ } from '@king-design/react'
import styled from 'styled-components'
import { CustomPageContainer } from 'src/components'
import AlarmTactics from 'src/containers/MonitorAlarmTemplate'

const MonitorAlarmTactics: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={className}>
      <CustomPageContainer title={_$('触发条件模版')}>
        <AlarmTactics />
      </CustomPageContainer>
    </div>
  )
}

export default styled(MonitorAlarmTactics)``
